import { Subscription } from 'rxjs';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { Title, Meta } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { BlogEntry } from '../../models/blog-models.model';
import { Component, Inject, PLATFORM_ID } from '@angular/core';
import { BlogService } from '../../services/blog/blog.service';
import { environment } from '../../../environments/environment';

// interface BlogEntry {
//   _id: string;
//   image: string[];
// }

@Component({
  selector: 'app-blog-page',
  templateUrl: './blog-page.component.html',
  styleUrl: './blog-page.component.scss'
})
export class BlogPageComponent {
  private readonly siteUrl = environment.SITE_URL;

  // LOADERS
  public loader: boolean = false;

  // BLOGS
  public blogEntries: Array<BlogEntry> = [];
  public cardFeatured!: BlogEntry;

  // PARAMS
  private queryParamsSubscription!: Subscription;
  public currentPage = 1;
  public count = 0;
  public styleCards: boolean = false;
  public animation: boolean = false;

  private blogEntriesSubscription!: Subscription;

  public blogTopics = [
    { label: "Construcción", icon: "building-2" },
    { label: "Materiales Sostenibles", icon: "leaf" },
    { label: "Costos de Obra", icon: "piggy-bank" },
    { label: "Permisos y Licencias", icon: "file-text" },
    { label: "Arquitectura Moderna", icon: "landmark" },
    { label: "Eficiencia Energética", icon: "zap" },
    { label: "Casos de Éxito", icon: "award" },
    // { label: "Mantenimiento", icon: "wrench" },
    // { label: "Remodelación", icon: "hammer" },
    // { label: "Vivienda", icon: "home" },
    // { label: "Sector Público", icon: "landmark" },
    // { label: "Industria", icon: "factory" },
    // { label: "Salud", icon: "activity" },
    // { label: "Innovación", icon: "lightbulb" },
    // { label: "Proyectos en CDMX", icon: "map-pin" }
  ];

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private blogService: BlogService,
    @Inject(PLATFORM_ID) private platformId: any,
    private titleService: Title, private metaService: Meta,
    @Inject(DOCUMENT) private document: Document,
  ) {
    this.setMetaTags();
  }

  ngOnInit(): void {
    this.loader = true;

    this.blogEntriesSubscription = this.blogService.getBlogEntries().subscribe({
      next: (entries) => {
        this.blogEntries = entries;
        this.cardFeatured = entries[0];
        this.loader = false;
      },
      error: (error) => {
        this.loader = false;
      }
    });

    this.getParametersInitialState();
  }

  async getParametersInitialState() {
    this.queryParamsSubscription = this.route.queryParams.subscribe(async (params) => {
      if (params['page'] != undefined) {
        this.currentPage = params['page'];
      } else {
        this.currentPage = 1;
      }
    });
  }

  setMetaTags() {
    const metaTitle = 'Blog de construcción, proyectos y mejores prácticas';
    const metaDescription = 'Ideas, tendencias y mejores prácticas en construcción en México: salud, industria, sector público y vivienda.';
    const url = `${this.siteUrl}/blog/`;
    const image = this.toAbsoluteUrl('/assets/images/blog/c8_maintance.webp');

    this.titleService.setTitle(metaTitle);
    this.metaService.updateTag({ name: 'description', content: metaDescription });


    this.metaService.updateTag({ name: "robots", content: "index, follow" });
    this.metaService.updateTag({ name: "description", content: metaDescription });
    this.setCanonicalUrl(url);

    this.metaService.updateTag({ name: "keywords", content: "Construcción, Proyectos, Seguridad en obra, Llave en mano, Cumplimiento normativo, México" });

    this.metaService.updateTag({ property: "og:type", content: "website" });
    this.metaService.updateTag({ property: "og:locale", content: "es_MX" });
    this.metaService.updateTag({ property: "og:site_name", content: "Paredes y Asociados" });

    this.metaService.updateTag({ property: "og:title", content: "Paredes y Asociados | " + metaTitle });
    this.metaService.updateTag({ property: "og:description", content: metaDescription });
    this.metaService.updateTag({ property: "og:url", content: url });
    this.metaService.updateTag({ property: 'og:image', content: image });
    this.metaService.updateTag({ property: 'og:image:alt', content: 'Paredes y Asociados' });

    this.metaService.updateTag({ name: "twitter:card", content: "summary_large_image" });
    this.metaService.updateTag({ name: "twitter:title", content: "Paredes y Asociados | " + metaTitle });
    this.metaService.updateTag({ name: "twitter:description", content: metaDescription });
    this.metaService.updateTag({ name: "twitter:url", content: url });
    this.metaService.updateTag({ name: "twitter:image", content: image });
  }

  private setCanonicalUrl(url: string): void {
    const head = this.document.head;
    let link = this.document.querySelector("link[rel='canonical']") as HTMLLinkElement | null;
    if (!link) {
      link = this.document.createElement('link');
      link.setAttribute('rel', 'canonical');
      head.appendChild(link);
    }
    link.setAttribute('href', url);
  }

  private toAbsoluteUrl(path: string): string {
    if (!path) {
      return `${this.siteUrl}/assets/images/logos/logo-full.webp`;
    }
    if (path.startsWith('http://') || path.startsWith('https://')) {
      return path;
    }
    if (!path.startsWith('/')) {
      path = `/${path}`;
    }
    return `${this.siteUrl}${path}`;
  }

  ngOnDestroy(): void {
    if (this.queryParamsSubscription) {
      this.queryParamsSubscription.unsubscribe();
    }
    if (this.blogEntriesSubscription) {
      this.blogEntriesSubscription.unsubscribe();
    }
  }

  onPageChange($event: any) {
    this.currentPage = $event;
    this.router.navigate(['blog'], {
      queryParams: { page: $event },
      queryParamsHandling: 'merge',
    });
  }

  goToPost(id: string, title: string) {
    let name = title
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/ñ/g, 'n')
      .replace(/[^a-z0-9\s-]/g, '')
      .trim()
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-');

    this.router.navigate([`/blog/${name}/${id}`]);

    if (isPlatformBrowser(this.platformId)) {
      setTimeout(() => {
        let element = document.querySelector('#nav') as HTMLElement;
        let topOfElement = element.offsetTop - 100;
        window.scroll({ top: topOfElement, behavior: 'smooth' });
      }, 200);
    }
  }

  getImageSrc(entry: any): string {
    const img = entry?.image;
    let src = Array.isArray(img) && img.length > 0 ? img[0] : (typeof img === 'string' ? img : 'assets/images/blog/c1_company.webp');
    if (src && !src.startsWith('http') && !src.startsWith('/')) {
      src = '/' + src;
    }
    return src;
  }

  getContent(text: any, number: number) {
    const limiteCaracteres = number;
    if (text.length > limiteCaracteres) {
      return text.slice(0, limiteCaracteres) + "...";
    }
    return text;
  }

  formatDateToShort(inputDate: string): string {
    const months: string[] = [
      "Ene.", "Feb.", "Mar.", "Abr.", "May.", "Jun.",
      "Jul.", "Ago.", "Sep.", "Oct.", "Nov.", "Dic."
    ];
    const monthIndexMap: { [key: string]: number } = {
      "enero": 0,
      "febrero": 1,
      "marzo": 2,
      "abril": 3,
      "mayo": 4,
      "junio": 5,
      "julio": 6,
      "agosto": 7,
      "septiembre": 8,
      "octubre": 9,
      "noviembre": 10,
      "diciembre": 11
    };
    const [day, monthName, year] = inputDate.split(" de ");
    const monthIndex = monthIndexMap[monthName.toLowerCase()];
    return `${day} ${months[monthIndex]} ${year}`;
  }

  goTo(path: any) {
    if (isPlatformBrowser(this.platformId)) {
      setTimeout(() => {
        let element = document.querySelector('#' + path) as HTMLElement;
        let topOfElement = element.offsetTop - 100;
        window.scroll({ top: topOfElement, behavior: 'smooth' });
      }, 200);
    }
  }

}
